module.exports = __webpack_public_path__ + "static/media/DG8960-ben4.1bf13ad7.png";